import initialMetricsPublisher from "src/metrics";

export const buttonClickMetricsPublisher = initialMetricsPublisher.newChildActionPublisherForMethod("button-clicks")
export const latencyMetricsPublisher = initialMetricsPublisher.newChildActionPublisherForMethod("latency")
export const apiFatalsMetricsPublisher = initialMetricsPublisher.newChildActionPublisherForMethod("api-fatals")
export const apiSuccessMetricsPublisher = initialMetricsPublisher.newChildActionPublisherForMethod("api-success")
export const timezoneMetricsPublisher = initialMetricsPublisher.newChildActionPublisherForMethod("timezone-operations")
